const GeneralServices = (axiosInstance) => ({
  uploadFile: async (file: File, userId: string) => {
    const formData = new FormData();
    formData.append("file", file);

    return axiosInstance.post(`/uploads3?user_id=${userId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  processFile: async (file: File, sessionId: string, userId: string) => {
    const formData = new FormData();
    formData.append("file", file);

    return axiosInstance.post(
      `/resume?session_id=${sessionId}&user_id=${userId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  readFile: async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    return axiosInstance.post("/read_file", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  sendMessage: async (userInput: string, sessionId: string, userId: string) => {
    return axiosInstance.post("/chat", {
      user_input: userInput,
      session_id: sessionId,
      user_id: userId,
    });
  },

  sendFeedback: async ({ qa_id, correct_answer, was_util }) => {
    return axiosInstance.post(
      `/feedback?qa_id=${qa_id}&correct_answer=${correct_answer}&was_util=${was_util}`
    );
  },

  generateConceptMap: async (file: File, sessionId: string, userId: string) => {
    const formData = new FormData();
    formData.append("file", file);

    return axiosInstance.post(
      `/concept-map?session_id=${sessionId}&user_id=${userId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  sendToModel: async (text: string, sessionId: string, userId: string) => {
    return axiosInstance.post("/chat", {
      user_input: text,
      session_id: sessionId,
      user_id: userId,
    });
  },

  fetchFiles: async (userId: string) => {
    return axiosInstance.get(`/files?user_id=${userId}`);
  },

  selectFile: async (userId: string, filename: string) => {
    return axiosInstance.get(
      `/selectFiles?user_id=${userId}&filename=${filename}`,
      {
        responseType: "blob",
      }
    );
  },

  fetchWelcomeMessage: async () => {
    return axiosInstance.get("/welcome");
  },

  fetchSessions: async (userId) => {
    return axiosInstance.get(`/sessions?user_id=${userId}`);
  },

  fetchChatHistory: async (userId, sessionId) => {
    return axiosInstance.get(
      `/chats?user_id=${userId}&session_id=${sessionId}`
    );
  },
});

export default GeneralServices;
